module.exports = __webpack_public_path__ + "static/img/banner2.ae167ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ad/banner2.png
// module id = 0iW5
// module chunks = 1